import Vue from "vue";
import VueScript2 from "vue-script2";
import Adsense from "vue-google-adsense/dist/Adsense.min.js";
import "@/plugins/vuetify";
import firebase from "@/firebase";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import user, { awaitUserInit } from "@/store/user";
import VueGeolocation from "vue-browser-geolocation";

Vue.use(require("vue-script2"));
Vue.use(Adsense);
Vue.use(VueGeolocation);

Vue.config.productionTip = false;
firebase.auth.onAuthStateChanged((_user) => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");

  if (
    typeof process.env.VUE_APP_ENABLE_ADS !== "undefined" &&
    process.env.VUE_APP_ENABLE_ADS == "true"
  ) {
    awaitUserInit().then(() => {
      if (!user.state.premium) {
        VueScript2.load("//www.ezojs.com/ezoic/sa.min.js");
      }
    });
  }
});
